<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="show" class="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
        <Transition name="zoom">
          <div v-if="show" class="bg-white dark:bg-gray-800 w-full max-w-md rounded-[2.5rem] shadow-2xl overflow-hidden border border-gray-100 dark:border-gray-700">
            <!-- Icon Header -->
            <div :class="[
              'p-8 flex flex-col items-center text-center',
              type === 'danger' ? 'bg-rose-50 dark:bg-rose-900/20' : 'bg-blue-50 dark:bg-blue-900/20'
            ]">
              <div :class="[
                'w-20 h-20 rounded-3xl flex items-center justify-center mb-4 shadow-lg',
                type === 'danger' ? 'bg-rose-500 text-white shadow-rose-500/30' : 'bg-blue-500 text-white shadow-blue-500/30'
              ]">
                <Icon :icon="icon || (type === 'danger' ? 'mdi:alert-octagon' : 'mdi:help-circle')" class="text-4xl" />
              </div>
              <h3 class="text-2xl font-black text-gray-900 dark:text-white tracking-tight">{{ title }}</h3>
            </div>

            <!-- Content -->
            <div class="p-8 pt-6 text-center">
              <p class="text-gray-500 dark:text-gray-400 font-bold text-base leading-relaxed" v-html="message"></p>
            </div>

            <!-- Actions -->
            <div class="p-8 pt-0 flex gap-4">
              <button 
                @click="$emit('cancel')"
                class="flex-1 py-4 bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-300 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-gray-200 transition-all"
              >
                {{ cancelText || 'Cancelar' }}
              </button>
              <button 
                @click="$emit('confirm')"
                :class="[
                  'flex-1 py-4 text-white rounded-2xl font-black text-xs uppercase tracking-widest transition-all shadow-xl',
                  type === 'danger' ? 'bg-rose-500 shadow-rose-500/20 hover:bg-rose-600' : 'bg-blue-600 shadow-blue-500/20 hover:bg-blue-700'
                ]"
              >
                {{ confirmText || 'Confirmar' }}
              </button>
            </div>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { Icon } from "@iconify/vue";

export default {
  name: "ModalConfirm",
  components: { Icon },
  props: {
    show: Boolean,
    title: String,
    message: String,
    type: { type: String, default: 'primary' },
    icon: String,
    confirmText: String,
    cancelText: String
  }
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.zoom-enter-active { animation: zoomIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); }
.zoom-leave-active { animation: zoomOut 0.2s ease-in; }

@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.9) translateY(20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}
@keyframes zoomOut {
  from { opacity: 1; transform: scale(1); }
  to { opacity: 0; transform: scale(0.9) translateY(10px); }
}
</style>
